import React from 'react';

// Swipe je woning Logo Component - Clean, High-Conversion Design
const SwipeMatchLogo = ({ size = "default", variant = "color", className = "" }) => {
  const sizeConfig = {
    small: { text: "text-lg", icon: "w-5 h-5", gap: "gap-1.5" },
    default: { text: "text-xl", icon: "w-6 h-6", gap: "gap-2" },
    large: { text: "text-2xl", icon: "w-7 h-7", gap: "gap-2" },
    xlarge: { text: "text-3xl md:text-4xl", icon: "w-8 h-8 md:w-10 md:h-10", gap: "gap-2.5" }
  };

  const config = sizeConfig[size];
  const isWhite = variant === "white";
  
  return (
    <div className={`flex items-center ${config.gap} ${className}`}>
      {/* Icon - House with heart */}
      <div className={`relative ${config.icon} flex-shrink-0`}>
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          {/* House shape */}
          <path 
            d="M20 4L4 16V36H16V26H24V36H36V16L20 4Z" 
            fill={isWhite ? "white" : "#2E7D32"}
            className="drop-shadow-sm"
          />
          {/* Heart accent */}
          <path 
            d="M20 14C20 14 17 11 14.5 13C12 15 14.5 18 20 22C25.5 18 28 15 25.5 13C23 11 20 14 20 14Z"
            fill={isWhite ? "#1F3A5F" : "#fff"}
          />
        </svg>
      </div>
      
      {/* Text - Clean design without italic */}
      <div className={`flex items-baseline ${config.text} font-black tracking-tight`}>
        <span className={isWhite ? "text-white" : "text-[#2E7D32]"}>
          swipe
        </span>
        <span className={`font-medium mx-0.5 ${isWhite ? "text-white/60" : "text-[#9E9E9E]"}`}>
          je
        </span>
        <span className={isWhite ? "text-white" : "text-[#1F3A5F]"}>
          woning
        </span>
      </div>
    </div>
  );
};

// Compact icon-only version
const SwipeLogoIcon = ({ size = "default", variant = "color", className = "" }) => {
  const sizeConfig = {
    small: "w-8 h-8",
    default: "w-10 h-10",
    large: "w-12 h-12"
  };

  const isWhite = variant === "white";
  
  return (
    <div className={`${sizeConfig[size]} ${className}`}>
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <path 
          d="M20 4L4 16V36H16V26H24V36H36V16L20 4Z" 
          fill={isWhite ? "white" : "#2E7D32"}
        />
        <path 
          d="M20 14C20 14 17 11 14.5 13C12 15 14.5 18 20 22C25.5 18 28 15 25.5 13C23 11 20 14 20 14Z"
          fill={isWhite ? "#1F3A5F" : "#fff"}
        />
      </svg>
    </div>
  );
};

// Badge version for marketing
const SwipeLogoBadge = ({ className = "" }) => {
  return (
    <div className={`inline-flex items-center gap-2 bg-gradient-to-r from-[#2E7D32] to-[#1F3A5F] text-white px-4 py-2 rounded-full shadow-lg ${className}`}>
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
        <path d="M20 4L4 16V36H16V26H24V36H36V16L20 4Z" fill="white" />
        <path d="M20 14C20 14 17 11 14.5 13C12 15 14.5 18 20 22C25.5 18 28 15 25.5 13C23 11 20 14 20 14Z" fill="#2E7D32"/>
      </svg>
      <span className="font-black text-sm tracking-tight">swipe je woning</span>
    </div>
  );
};

// Short version for tight spaces
const SwipeLogoShort = ({ size = "default", variant = "color", className = "" }) => {
  const sizeClasses = {
    small: "text-lg",
    default: "text-xl",
    large: "text-2xl"
  };

  const isWhite = variant === "white";
  
  return (
    <div className={`flex items-center gap-1.5 font-black ${sizeClasses[size]} ${className}`}>
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
        <path d="M20 4L4 16V36H16V26H24V36H36V16L20 4Z" fill={isWhite ? "white" : "#2E7D32"}/>
        <path d="M20 14C20 14 17 11 14.5 13C12 15 14.5 18 20 22C25.5 18 28 15 25.5 13C23 11 20 14 20 14Z" fill={isWhite ? "#1F3A5F" : "#fff"}/>
      </svg>
      <span className={isWhite ? "text-white" : "text-[#1F3A5F]"}>SJW</span>
    </div>
  );
};

export { SwipeMatchLogo, SwipeLogoShort, SwipeLogoIcon, SwipeLogoBadge };
export default SwipeMatchLogo;
